import Account from "./Account";
import Dashboard from "./Dashboard/Routes";
import Inventory from "./Inventory";
import Menu from "./Menu/Routes";
import Voucher from "./Voucher";
import Reports from "./Reports/Routes";
import Settings from "./Settings/Routes";
import WeeklyMenu from "./WeeklyMenu/Routes";
import BillPrepare from "./BillPrepare/Routes";
import SMS from "./SMS/Routes";
import members from "./Members/Routes";
import Mail from "./Mail";

export default [...Account, ...Dashboard, ...Inventory, ...Menu, ...Reports, ...Voucher, ...Settings, ...WeeklyMenu, ...BillPrepare, ...SMS, ...members, ...Mail];
